import { memo, MouseEvent } from 'react';
import { Custom } from 'configs/theme';

import { IconButton, Loader, Error } from 'components';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

import clsx from 'clsx';
import { useStyles, CSSProps } from './style';

interface Props {
  title?: string;
  loading?: boolean;
  error?: boolean;
  action?: (e?: MouseEvent<HTMLDivElement>) => void;
  themeColor?: Custom;
}

const WidgetContainer: React.FC<Props> = ({
  children,
  title,
  loading = false,
  error = false,
  action,
  themeColor = 'lightBlue',
}) => {
  const cssProps: CSSProps = { background: themeColor };
  const classes = useStyles(cssProps);

  const content = error ? (
    <Error />
  ) : loading ? (
    <Loader themeColor="darkBlue" />
  ) : (
    children
  );

  return (
    <div className={classes.root}>
      <div
        className={clsx(classes.container, {
          [classes.centered]: loading || error,
        })}
      >
        {content}
      </div>
      <div
        className={clsx(classes.border, {
          [classes.pointer]: !!action,
        })}
        onClick={action}
      >
        {title ? <span className={classes.title}>{title}</span> : null}
        {action ? (
          <IconButton className={classes.iconBtn}>
            <ChevronRightIcon className={classes.icon} />
          </IconButton>
        ) : null}
      </div>
    </div>
  );
};

export default memo(WidgetContainer);
